<template>
    <AddTaskCustomField />
  </template>
  
  <script lang="ts">
  import { defineComponent } from "vue";
  import AddTaskCustomField from "../../components/TaskCustomFields/AddTaskCustomField.vue";
  
  export default defineComponent({
    name: "AddTaskCustomPage",
    components: {
      AddTaskCustomField,
    },
  });
  </script>